// QuickXorHash — the content fingerprint OneDrive / SharePoint keep for every
// file (driveItem.file.hashes.quickXorHash), so the browser can tell whether a
// file it is about to upload is already somewhere in a job folder, whatever it
// is named. Microsoft's algorithm: a 160-bit register; each input byte is
// XORed in at a bit position that advances 11 bits per byte (wrapping at 160);
// finally the 64-bit little-endian input length is XORed into the last 8
// bytes; the result is base64. Pure.
const WIDTH = 160;
const SHIFT = 11;

export function quickXorHash(bytes) {
  const data = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  const cells = new Uint8Array(WIDTH / 8);
  let pos = 0;
  for (let i = 0; i < data.length; i++) {
    const b = data[i];
    if (b) {
      const idx = pos >> 3, off = pos & 7;
      // the byte's 8 bits land at [pos, pos+8), spilling into the next cell
      cells[idx] ^= (b << off) & 0xff;
      if (off) cells[(idx + 1) % cells.length] ^= b >> (8 - off);
    }
    pos = (pos + SHIFT) % WIDTH;
  }
  let len = data.length;
  for (let i = 0; i < 8; i++) {
    cells[cells.length - 8 + i] ^= len & 0xff;
    len = Math.floor(len / 256);
  }
  let bin = "";
  for (const c of cells) bin += String.fromCharCode(c);
  return typeof btoa === "function" ? btoa(bin) : Buffer.from(cells).toString("base64");
}

// For a browser File / Blob.
export async function quickXorHashOfFile(file) {
  return quickXorHash(new Uint8Array(await file.arrayBuffer()));
}
